module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_manipuri.9d7652ad.mp3";